// @flow
/**
 * User: Mike Chung
 * Date: 6/1/2018
 * Time: 8:32 PM
 */

import React, {Fragment} from 'react';
import {Field} from "redux-form";
import {Button, Input, InputGroup, InputGroupAddon} from "reactstrap";

const renderTextField = ({
                             input,
                             label,
                             className,
                             warningMsg,
                             meta: {touched, error, warning},
                             ...rest
                         }) => {
    if (touched && warning) {
        className += " is-invalid";
    }
    return (
        <Fragment>
            <InputGroup>
                <Input className={className} {...input} {...rest}/>
                <InputGroupAddon addonType="append"><Button>Continue</Button></InputGroupAddon>
            </InputGroup>
            <div style={{display: touched && warning ? "block" : "none"}} className={"invalid-feedback"}>{warningMsg}</div>
        </Fragment>
    );
};

export default function ReduxFormTextFieldWithSubmit(props: any) {

    return (
        <Field component={renderTextField} {...props} />
    );
}


// WEBPACK FOOTER //
// ./src/components/form/ReduxFormTextFieldWithSubmit.js